import { useEffect } from 'react';

// INFO is an informational/notification screen. It has no input control — the
// notification text is rendered from the question label by GenericFieldWrapper.
// On mount we auto-write an acknowledgment to redux-form (same shape as other
// field inputs, e.g. SwitchInput), so an acknowledged INFO flows through the
// existing navigation and submit pipeline like any answered question.
const InfoInput = (props) => {
  const { id, typeName, order, input: { onChange } } = props;

  useEffect(() => {
    onChange({ id, typeName, order, result: true });
  }, []);

  return null;
};

export default InfoInput;
